<template>
  <div id="app">
    <div class="contact-badge  ">
      <div class="row">
        <div class="col-md-9"><p class="contact-badge-text">Jetzt direkt Verfügbarkeit Ihres Standortes prüfen!</p></div>
        <div class="col-md-3"><a class="contact-badge-link" href="#" v-on:click="showPanel">Standort prüfen</a></div>
      </div>
    </div>

    <div v-if="store.visible">
      <div  class="location-container">
        <LoadingComponent v-if="store.loading"></LoadingComponent>
        <component v-if="!store.loading" v-bind:is="store.panelComponent"></component>
      </div>
      <div class="divider"></div>
    </div>
  </div>
</template>

<script>
import LocationForm from "./components/LocationForm";
import MultipleForm from "./components/MultipleForm";
import { mapMutations } from 'vuex'
import LoadingComponent from "./components/LoadingComponent";

export default {
  name: 'app',
  data(){
    return {
      store: this.$store.state
    }
  },
  methods: {
      ...mapMutations([
              'showPanel'
      ]),
  },
  components: {
    LoadingComponent,
    LocationForm,
    MultipleForm
  }
}
</script>

<style>
  .divider{
    background: #333;
    height:2px;
  }
  .location-container{
    padding: 30px 0;
  }
</style>
